import React from 'react';
import Layout from '../components/layout/Layout';
import Reportes from '../components/reportes/Reportes';

export const ReportesPage = () => {
    return ( <Layout children={<Reportes />} /> );
}